// 新闻详情
<template>
  <div class="main">
    <div class="banana">
      <img src="../assets/img/banner/画板 2.png" alt />
    </div>
    <div class="center">
      <div class="nav">
        <p>
          当前位置：
          <span @click="shouye" class="navvv">首页</span>
          >
          <span @click="newsDetail" class="navvv">新闻中心</span>
        </p>
      </div>

      <!-- 正文 -->
      <div class="text">
        <h1>{{ this.newsDtlList.title }}</h1>
        <p v-html="this.newsDtlList.newcontent"></p>
        <!-- <p>由河南省建设科技协会、河南省建筑业协会、河南省装配式建筑产业发展协会、河南省房地产业协会、河南省钢结构协会联合主办，河南翔宇展览服务有限公司承办的“ 2021中国（郑州）装配式建筑与绿色建筑科技产品博览会（以下简称：中国（郑州）筑博会）”定于2021年7月9日-11日在郑州国际会展中心举办。为办好此次活动，按照联合举办中国（郑州）筑博会文件（豫建科协［2020］27号）的总体布置和规划，结合建筑行业相关业务需要，现将我会在中国（郑州）筑博会中主导的专题展示内容和“2021 中国（郑州）EPC工程建设管理模式及绿色建造高峰论坛”予以具体安排，望根据本单位实际，按照本通知和豫建科协［2020］27号通知内容，一并自愿报名，积极参加。 一、专题展示内容 （一）装配式建筑及配套设施 1、装配式建筑EPC工程建设管理模式成果展示。 2、装配式建筑设计：方案设计、初设及施工图设计、构件深化设计、设计软件、AEC 软件、BIM 咨询、数据处理系统。 3、装配式建筑结构：装配式混凝土结构、装配式钢结构、模块化建筑、装配式木结构、装配式密封系统、预制构件成品、装配式综合管廊、预制构件生产设备、链接件、预埋件及配件、PC结构胶、装配式建筑胶。 4、绿色装配式房屋：轻钢房屋系列、集成房屋系列、模块化房屋系列、集装箱房屋系列、木结构房屋系列、铝合金房屋系列、异形房屋系列、装配式篷房系列 。 5、国家级、省级装配式产业基地及相关企业。 （二）建设施工成果展 1、致敬建筑人，致敬“工匠精神”，表彰建筑各岗位优秀的从业人员，并展示其先进事迹与工作成果。 2、建筑施工企业形象展示、精品工程、绿色施工理念示范项目展示；科技成果、先进施工管理技术应用成果展示，以及近年来在建筑施工技术方面的创新成果、前沿思想、经典案例、地域特色等。 （三）绿色施工生态设备及构件: 组合式吊装房、折叠箱式房屋集装箱房、彩钢活动房、拼装式活动房、装配式活动房、建筑垃圾再生骨料设备、构件化围墙、围栏、地面、光伏发电照明、成品垃圾管道等。 （四）全装修与内装工业化：整体卫生间、整体厨房，整体书房、整体收纳柜、整体墙面、集成吊顶、生态集成房屋、智能家居系统、室内楼梯、家居一体化及内装工业化相关的集成技术和部品。</p> -->
      </div>

      <!-- 上一篇或下一篇 -->
      <!-- <div class="next">
        <p>
          上一篇：
          <span class="blackTxt">关于公布2020年度河南省建筑业新技术应用示范工程（第二批）立项名单的通知</span>
        </p>
        <p>
          下一篇：
          <span class="blackTxt">关于转发举办《建筑施工安全技术统一规范》和《建筑施工安全检查标准》宣贯培训班</span>
        </p>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      newid: "",
      newsDtlList:{}
    };
  },
  mounted() {
    this.newid = this.$route.query.newid;
    this.newsDetailData();
  },
  methods: {
    // 获取新闻详情
    newsDetailData() {
      const _this = this;
      this.$axios({
        url: "http://192.168.10.206:11003/pushnews/queryInfo",
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          newid: this.newid
        },
      }).then((response) => {
        this.newsDtlList = response.data;
      }).catch((error)=>{
        console.log(error);
      });
    },

    newsDetail() {
      this.$router.replace("/news");
    },
    shouye() {
      this.$router.replace("/");
    },
  },
  components: {},
};
</script>

<style scoped lang="less">
.main {
  width: 100%;
  font-size: 16px;
  .banana {
    width: 100%;
    // background: url("../assets/img/banner/画板 2.png") center no-repeat;
    // background-size: cover;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .center {
    width: 1160px;
    // padding: 0rem 3.6rem;
    margin: 0 auto;
    box-sizing: border-box;
    overflow: hidden;
    .nav {
      width: 100%;
      border-bottom: 1px solid #a0a0a0;
      opacity: 1;
      font-size: 12px;
      font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
      font-weight: 400;
      text-align: justifyLeft;
      color: #666666;
      line-height: 36px;
    }
    .text {
      width: 100%;
      margin-top: 83px;
      margin-bottom: 160px;
      h1 {
        opacity: 1;
        font-size: 25px;
        font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
        font-weight: 400;
        text-align: center;
        color: #333333;
        border-bottom: 4px solid #4279db;
        padding-bottom: 12px;
        margin-bottom: 57px;
      }
      p {
        text-indent: 2em;
        opacity: 1;
        font-size: 14px;
        font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
        font-weight: 400;
        text-align: justifyLeft;
        color: #333333;
        line-height: 26px;
      }
    }
    .next {
      height: 80px;
      width: 100%;
      margin-bottom: 83px;
      p {
        text-indent: 2em;
        opacity: 1;
        font-size: 14px;
        font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
        font-weight: 400;
        text-align: justifyLeft;
        color: #333;
        .blackTxt {
          color: #666;
        }
        .blackTxt:hover {
          cursor: pointer;
          color: #333;
        }
      }
    }
  }
}
</style>
